import axios from 'axios';
import apisUrls from '../urls';

const getAllDevicesBrands = (paramsFilter) => {
  return axios.get(apisUrls?.getDevicesBrands);
};

export default getAllDevicesBrands;
